module.exports = __webpack_public_path__ + "static/pietobar-beceef8a3f1d8a460c793926eba5233f.gif";